/* eslint-disable no-shadow, @typescript-eslint/naming-convention */
export enum ExternalEventPrefix {
    Form = 'bigDirektForm',
}
